 'use strict';

import autoComplete from '@tarekraafat/autocomplete.js';
import { getAbsoluteUrl } from './@tix02/utility/url';

const _getConfig = () => {
	return acConfig ?? {};
}


(function() {
	const inputSelector = '#materials-inl-s';
	const searchControl = document.querySelector(inputSelector);
	if (!searchControl) {
		return;
	}
	
	const form = searchControl.closest('form.search-frm');
	if (!form) {
		return;
	}
	
	const formUrl = form.getAttribute('action');
	if (!formUrl) {
		throw new Error('Autocomplete: missing URL');
	}
	
	const config = _getConfig();
	
	const searchUrl = new URL(getAbsoluteUrl(formUrl));
	searchUrl.pathname = `${searchUrl.pathname}.json`;
	
	if( config && config.formData ) {
		for(let prop in config.formData) {
			searchUrl.searchParams.set(prop, config.formData[prop]);
		}
	}
	
	form.addEventListener('submit', event => {
		event.preventDefault();
	});
	
	const requestHeaders = new Headers();
	requestHeaders.append('X-Requested-With', 'XMLHttpRequest');

	const _fetchResults = async (query) => {		
		searchUrl.searchParams.set('s', query);
		
		// then applications
		const response = await fetch(searchUrl.href, { headers: requestHeaders });
		const json = await response.json();
		return json.results;
	};
	
	
	const _onSelect = (value) => {
		document.location.href = value.permalink;
	};
	
	const autocomplete = new autoComplete({
		name: 'ac-material',
		selector: inputSelector,
		threshold: 4,
		data: {
			src: _fetchResults,
			// Data 'Object' key to be searched
			keys: ['title', 'shortDescription'],
			
			filter: (results) => {
				// ensure to return only one time the result 
				const existingIds = [];
				return results.filter((row) => {
					if( existingIds.includes(row.value.id) ) {
						return false;
					}
					existingIds.push(row.value.id);
					return true;
				});
			}
		},
		
		resultsList: {
			element: (list, data) => {
				if (!data.results.length) {
					const m = document.createElement('li');
					m.classList.add('no-result');
					m.innerHTML = config.i18n && config.i18n.NO_RESULTS.replace('{0}', data.query) || 'No result';
					list.prepend(m);
				}
			},
			class: 'ac-results-list',
			noResults: true,
			maxResults: 15,
			tabSelect: true,
		},

		resultItem: {
			element: (item, data) => {
				item.innerHTML = `<div class="autocomplete-suggestion">
					<div class="suggestion-item">
						<div class="suggestion-title">${ data.key === 'title' && data.match || data.value.title }</div>
						<div class="suggestion-description">${ data.key === 'shortDescription' && data.match || data.value.shortDescription }</div>
					</div>
				</div>`;
		
			},
			highlight: 'autocomplete_highlight',
			selected: 'autocomplete_selected',
		},
		
		events: {
			input: {
				selection: event => {
					const selection = event.detail.selection.value;
					_onSelect(selection);
				},
		
				focus: () => {
					if (autocomplete.input.value.length) {
						autocomplete.start();
					}
				},
			}
		},
	});
	
	
	const applicationSwitches = Array.from(form.querySelectorAll('.application-sw'));
	
	applicationSwitches.forEach(sw => {
		sw.addEventListener('click', () => {
			const selectedApplications = applicationSwitches.filter(a => a.checked).map(a => a.value);
			instantSearch.matchIn('Applications', selectedApplications);
		});
	});
})();


/*
 
class InstantSearch {
	#items = [];
	#identifiers = [];
	#matchingIdentifiers = [];
	
	
	constructor(items) {
		items.forEach(item => {
			const uid = crypto.randomUUID();
			item.dataset.id = uid;
			this.#items.push(item);
			this.#identifiers.push(uid);
		});
		this.#matchingIdentifiers = this.#identifiers;
		this.updateUi();
	};
	
	item(id) {
		return this.#items.find(item => item.dataset.id === id);
	};
	
	reset() {
		this.#matchingIdentifiers = this.#identifiers;
		this.updateUi();
		return this;
	};
	
	match(name, value) {
		const v = value.trim();
		if( v === '' ) {
			this.#matchingIdentifiers = this.#identifiers;
			this.updateUi();
			return this;
		}
		
		const re = new RegExp(`${v}`, 'i');
		this.#matchingIdentifiers = this.#filter(name, re);
		
		this.updateUi();
		return this;
	};
	
	
	matchAll(name, values) {
		const _values = values.filter(v => v.trim() !== '');
		if( _values.length === 0 ) {
			return this;
		}
		
		values.forEach(value => {
			const v = value.trim();
			const re = new RegExp(`${v}`, 'i');
			this.#matchingIdentifiers = this.#filter(name, re);
		});
		
		this.updateUi();
		return this;
	};
	
	
	matchIn(name, values) {
		const _values = values.filter(v => v.trim() !== '');
		if( _values.length === 0 ) {
			this.#matchingIdentifiers = [];
			this.updateUi();
			return this;
		}
		
		const exp_s = _values.join('|');
		const re = new RegExp(`${exp_s}`, 'i');
		this.#matchingIdentifiers = this.#filter(name, re);
		
		this.updateUi();
		return this;
	};
	
	
	#filter(name, re) {
		return this.#matchingIdentifiers.filter(id => {
			const c = this.item(id);
			if(! c ) {
				return false;
			}
			const f = c.dataset[`filters${name}`];
			if(! f ) {
				return false;
			}
			
			return re.test(f);
		});
	}
	
	updateUi() {
		const className = 'instant-search-hidden';
		this.#items.forEach(item => {
			if( this.#matchingIdentifiers.includes(item.dataset.id) ) {
				return item.classList.remove(className);
			}
			return item.classList.add(className);
		});
	};
	
	results() {
		return this.#items.filter(item => this.#matchingIdentifiers.includes(item.dataset.id));
	};
};
*/

/*
(function() {
	const s = document.getElementById('materials-inl-s');
	if(! s ) {
		return;
	}
	let params = {};
	
	const controls = s.closest('.item-list-controls');
	const cards = Array.from(s.closest('.-archive-products').querySelectorAll('.card.type-product'));
	const instantSearch = new InstantSearch(cards);
	
	s.addEventListener('keyup', e => {
		const keywords = e.target.value.trim().split(/\s/).filter(v => v.trim() !== '');
		instantSearch.reset();
		instantSearch.matchAll('Title', keywords);
		//const results = instantSearch.results();
	});
	
	
	const applicationSwitches = Array.from(controls.querySelectorAll('.application-sw'));
	
	applicationSwitches.forEach(sw => {
		sw.addEventListener('click', () => {
			const selectedApplications = applicationSwitches.filter(a => a.checked).map(a => a.value);
			instantSearch.matchIn('Applications', selectedApplications);
		});
	});
})();
*/